import { createSlice } from "@reduxjs/toolkit";

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    loading: false,
    mailingConfigsLoading: false,
    syslogConfigLoading: false,
    error: null,
    mailingConfigsError: null,
    syslogConfigError: null,
    timePeriod: 0,
    artifactPeriod: 0,
    mailingConfigs: {
      server: "",
      port: "",
      security: "",
      senderEmail: "",
    },
    mailingActive: false,
    mailContent: {
      mailSubject: "",
      mailBody: "",
    },
    mailRecipientList: [],
    syslogActive: false,
    syslogServer: "",
    syslogPort: "",
    syslogConnection: "",
    dumpStatus: "",
    dumpDate: "",
    dumpInfo: { message: "", startedAt: null, fileAvailable: false, fileSize: null },
    restoreStatus: "",
    restoreInfo: { message: "", startedAt: null, upload: null },
    tconfig: "",
    slackconf: {},
    // syslogServerIP: "",
    // syslogServerPort: "",
    customSignatures: [],
    customSignaturesLoading: false,
    customSignatureFile: null,
    customSignatureUploading: false,
    deleteCustomSignatureId: "",
    deleteCustomSignatureLoading: false,
    editCustomSignatureId: "",
    editCustomSignatureLoading: false,
    hostname: "",
    uniqueId: "",
    uniqueIdLoading: false,
    testSyslogServerLoading: false,
    testSyslogServerError: null,
    prtgConfigs: {},
    prtgConfigsLoading: false,
    setPrtgConfigsLoading: false,
    updateSchedulerConfigs: {},
    updateSchedulerConfigsLoading: false,
    setUpdateSchedulerConfigsLoading: false,
    ldapConfigs: {},
    ldapConfigsLoading: false,
    setLdapConfigsLoading: false,
    ldapStatusActive: false,
    ldapStatusLoading: false,
    llmSettings: {},
    llmSettingsLoading: false,
    setLlmSettingsLoading: false,
    llmTestLoading: false,
    llmTestResult: null,
    toggleLlmLoading: false,
    coreMap: {},
    coreServers: [],
    coreServersLoading: false,
    // keyed by submit type: api_ui | mail_gateway | web
    autoSubmission: { api_ui: {}, mail_gateway: {}, web: {} },
    autoSubmissionLoading: false,
  },
  reducers: {
    requestTimePeriod: (state) => {
      state.loading = true;
    },
    successTimePeriod: (state, payload) => {
      state.loading = false;
      state.error = null;
      state.timePeriod = payload.payload;
    },
    failureTimePeriod: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    updateTimePeriodRequest: (state) => {
      state.loading = true;
    },
    updateTimePeriodSuccess: (state, payload) => {
      state.loading = false;
      state.error = null;
      state.timePeriod = payload.payload;
    },
    updateTimePeriodFailure: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    requestArtifactPeriod: (state) => {
      state.loading = true;
    },
    successArtifactPeriod: (state, payload) => {
      state.loading = false;
      state.error = null;
      state.artifactPeriod = payload.payload;
    },
    failureArtifactPeriod: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    updateArtifactPeriodRequest: (state) => {
      state.loading = true;
    },
    updateArtifactPeriodSuccess: (state, payload) => {
      state.loading = false;
      state.error = null;
      state.artifactPeriod = payload.payload;
    },
    updateArtifactPeriodFailure: (state, payload) => {
      state.loading = false;
      state.error = payload.payload;
    },
    requestGetMailingConfigs: (state) => {
      state.mailingConfigsLoading = true;
    },
    successGetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigs = payload.payload;
      state.mailingActive = payload.payload.active;
    },
    failureGetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestSetMailingConfigs: (state) => {
      state.mailingConfigsLoading = true;
    },
    successSetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigs = payload.payload;
      state.mailingActive = payload.payload.active;
    },
    failureSetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestResetMailingConfigs: (state) => {
      state.mailingConfigsLoading = true;
    },
    successResetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigs = payload.payload;
      state.mailingActive = payload.payload.active;
    },
    failureResetMailingConfigs: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestGetMailRecipients: (state) => {
      state.mailingConfigsLoading = true;
      state.mailingConfigsError = false;
    },
    successGetMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = false;

      state.mailRecipientList = payload.payload.recipients;
    },
    failureGetMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestAddMailRecipients: (state) => {
      state.mailingConfigsLoading = true;
      state.mailingConfigsError = false;
    },
    successAddMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = false;

      state.mailRecipientList = payload.payload.recipients;
    },
    failureAddMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestDeleteMailRecipients: (state) => {
      state.mailingConfigsLoading = true;
      state.mailingConfigsError = false;
    },
    successDeleteMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = false;

      state.mailRecipientList = payload.payload.recipients;
    },
    failureDeleteMailRecipients: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestUpdateMailingActive: (state) => {
      state.mailingConfigsLoading = true;
    },
    successUpdateMailingActive: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingActive = payload.payload.active;
    },
    failureUpdateMailingActive: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestGetMaliciousSubmissionMailContent: (state) => {
      state.mailingConfigsLoading = true;
    },
    successGetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailContent = payload.payload;
    },
    failureGetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestSetMaliciousSubmissionMailContent: (state) => {
      state.mailingConfigsLoading = true;
    },
    successSetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailContent = payload.payload;
    },
    failureSetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    requestResetMaliciousSubmissionMailContent: (state) => {
      state.mailingConfigsLoading = true;
    },
    successResetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailContent = payload.payload;
    },
    failureResetMaliciousSubmissionMailContent: (state, payload) => {
      state.mailingConfigsLoading = false;
      state.mailingConfigsError = payload.payload;
    },
    dumpDatabaseRequest: () => {},
    requestDumpStatus: () => {},
    updateDumpStatus: (state, action) => {
      const { dumpStatus, dumpDate, message, startedAt, fileAvailable, fileSize } = action.payload;
      state.dumpStatus = dumpStatus;
      state.dumpDate = dumpDate;
      state.dumpInfo = {
        message: message || "",
        startedAt: startedAt || null,
        fileAvailable: Boolean(fileAvailable),
        fileSize: fileSize ?? null,
      };
    },
    requestRestoreStatus: () => {},
    updateRestoreStatus: (state, action) => {
      const { restoreStatus, message, startedAt, upload } = action.payload;
      state.restoreStatus = restoreStatus;
      state.restoreInfo = {
        message: message || "",
        startedAt: startedAt || null,
        upload: upload || null,
      };
    },
    requestGetSyslogConfig: (state) => {
      state.syslogConfigLoading = true;
    },
    successGetSyslogConfig: (state, action) => {
      state.syslogConfigLoading = false;

      state.syslogConfigError = false;
      state.syslogActive = action.payload.active;
      state.syslogServer = action.payload.server;
      state.syslogPort = action.payload.port;
      state.syslogConnection = action.payload.connection;
    },
    failureGetSyslogConfig: (state, payload) => {
      state.syslogConfigLoading = false;
      state.syslogConfigError = payload.payload;
    },
    requestSetSyslogConfig: (state) => {
      state.syslogConfigLoading = true;
    },
    successSetSyslogConfig: (state) => {
      state.syslogConfigLoading = false;
      state.syslogConfigError = false;
    },
    failureSetSyslogConfig: (state, payload) => {
      state.syslogConfigLoading = false;
      state.syslogConfigError = payload.payload;
    },
    requestDeleteSyslogConfig: (state, payload) => {
      state.syslogConfigLoading = true;
    },
    successDeleteSyslogConfig: (state, action) => {
      state.syslogConfigLoading = false;

      state.syslogConfigError = false;
      state.syslogServer = "";
      state.syslogPort = "";
      state.syslogConnection = "";
    },
    failureDeleteSyslogConfig: (state, payload) => {
      state.syslogConfigLoading = false;
      state.syslogConfigError = payload.payload;
    },
    requestSetTelegramConfig: (state) => {
      state.loading = true;
    },
    successSetTelegramConfig: (state) => {
      state.loading = false;
    },
    failureSetTelegramConfig: (state) => {
      state.loading = false;
    },
    requestGetTelegramConfig: (state) => {
      state.loading = true;
    },
    successGetTelegramConfig: (state, payload) => {
      state.loading = false;
      state.tconfig = payload.payload;
    },
    failureGetTelegramConfig: (state) => {
      state.loading = false;
    },
    requestSetSlackConfig: (state) => {
      state.loading = true;
    },
    successSetSlackConfig: (state) => {
      state.loading = false;
    },
    failureSetSlackConfig: (state) => {
      state.loading = false;
    },
    requestGetSlackConfig: (state) => {
      state.loading = true;
    },
    successGetSlackConfig: (state, payload) => {
      state.loading = false;
      state.slackconf = payload.payload;
    },
    failureGetSlackConfig: (state) => {
      state.loading = false;
    },
    RequestCustomSignatureUpload: (state) => {
      state.customSignatureUploading = true;
    },
    SuccessCustomSignatureUpload: (state) => {
      state.customSignatureUploading = false;
    },
    FailureCustomSignatureUpload: (state) => {
      state.customSignatureUploading = false;
    },
    SetCustomSignatureFile: (state, action) => {
      state.customSignatureFile = action.payload;
    },
    RequestCustomSignatures: (state) => {
      state.customSignaturesLoading = true;
    },
    SuccessCustomSignatures: (state, action) => {
      state.customSignatures = action.payload;
      state.customSignaturesLoading = false;
    },
    FailureCustomSignatures: (state) => {
      state.customSignatures = [];
      state.customSignaturesLoading = false;
    },
    RequestDeleteCustomSignature: (state, action) => {
      state.deleteCustomSignatureId = action.payload;
      state.deleteCustomSignatureLoading = true;
    },
    SuccessDeleteCustomSignature: (state) => {
      state.deleteCustomSignatureId = "";
      state.deleteCustomSignatureLoading = false;
    },
    FailureDeleteCustomSignature: (state) => {
      state.deleteCustomSignatureId = "";
      state.deleteCustomSignatureLoading = false;
    },
    RequestEditCustomSignature: (state, action) => {
      state.editCustomSignatureId = action.payload;
      state.editCustomSignatureLoading = true;
    },
    SuccessEditCustomSignature: (state) => {
      state.editCustomSignatureId = "";
      state.editCustomSignatureLoading = false;
    },
    FailureEditCustomSignature: (state) => {
      state.editCustomSignatureId = "";
      state.editCustomSignatureLoading = false;
    },
    RequestGetHostname: () => {},
    SuccessGetHostname: (state, action) => {
      state.hostname = action.payload;
    },
    FailureGetHostname: () => {},
    RequestSetHostname: () => {},
    SuccessSetHostname: () => {},
    FailureSetHostname: () => {},
    RequestUniqueId: (state) => {
      state.uniqueIdLoading = true;
    },
    SuccessUniqueId: (state, action) => {
      state.uniqueId = action.payload;
      state.uniqueIdLoading = false;
    },
    FailureUniqueId: (state) => {
      state.uniqueIdLoading = false;
      state.uniqueId = "";
    },
    RequestTestSyslogServer: (state) => {
      state.testSyslogServerLoading = true;
      state.testSyslogServerError = null;
    },
    SuccessTestSyslogServer: (state, action) => {
      state.testSyslogServerLoading = false;
      state.testSyslogServerError = null;
    },
    FailureTestSyslogServer: (state) => {
      state.testSyslogServerLoading = false;
    },
    RequestGetPrtgConfigs: (state) => {
      state.prtgConfigsLoading = true;
    },
    SuccessGetPrtgConfigs: (state, action) => {
      state.prtgConfigs = action.payload;
      state.prtgConfigsLoading = false;
    },
    FailureGetPrtgConfigs: (state) => {
      state.prtgConfigsLoading = false;
    },
    RequestSetPrtgConfigs: (state) => {
      state.setPrtgConfigsLoading = true;
    },
    SuccessSetPrtgConfigs: (state) => {
      state.setPrtgConfigsLoading = false;
    },
    FailureSetPrtgConfigs: (state) => {
      state.setPrtgConfigsLoading = false;
    },
    RequestGetUpdateSchedulerConfigs: (state) => {
      state.updateSchedulerConfigsLoading = true;
    },
    SuccessGetUpdateSchedulerConfigs: (state, action) => {
      state.updateSchedulerConfigs = action.payload;
      state.updateSchedulerConfigsLoading = false;
    },
    FailureGetUpdateSchedulerConfigs: (state) => {
      state.updateSchedulerConfigsLoading = false;
    },
    RequestSetUpdateSchedulerConfigs: (state) => {
      state.setUpdateSchedulerConfigsLoading = true;
    },
    SuccessSetUpdateSchedulerConfigs: (state) => {
      state.setUpdateSchedulerConfigsLoading = false;
    },
    FailureSetUpdateSchedulerConfigs: (state) => {
      state.setUpdateSchedulerConfigsLoading = false;
    },
    RequestGetLdapStatus: (state) => {
      state.ldapStatusLoading = true;
    },
    SuccessGetLdapStatus: (state, action) => {
      state.ldapStatusActive = !!action.payload?.active;
      state.ldapStatusLoading = false;
    },
    FailureGetLdapStatus: (state) => {
      state.ldapStatusActive = false;
      state.ldapStatusLoading = false;
    },
    RequestGetLdapConfigs: (state) => {
      state.ldapConfigsLoading = true;
    },
    SuccessGetLdapConfigs: (state, action) => {
      state.ldapConfigs = action.payload;
      state.ldapConfigsLoading = false;
    },
    FailureGetLdapConfigs: (state) => {
      state.ldapConfigsLoading = false;
    },
    RequestSetLdapConfigs: (state) => {
      state.setLdapConfigsLoading = true;
    },
    SuccessSetLdapConfigs: (state) => {
      state.setLdapConfigsLoading = false;
    },
    FailureSetLdapConfigs: (state) => {
      state.setLdapConfigsLoading = false;
    },
    RequestToggleLdapStatus: (state) => {
      // This action doesn't change loading state, just triggers the saga
    },
    RequestGetLlmSettings: (state) => {
      state.llmSettingsLoading = true;
    },
    SuccessGetLlmSettings: (state, action) => {
      state.llmSettings = action.payload;
      state.llmSettingsLoading = false;
    },
    FailureGetLlmSettings: (state) => {
      state.llmSettingsLoading = false;
    },
    RequestSetLlmSettings: (state) => {
      state.setLlmSettingsLoading = true;
    },
    SuccessSetLlmSettings: (state) => {
      state.setLlmSettingsLoading = false;
    },
    FailureSetLlmSettings: (state) => {
      state.setLlmSettingsLoading = false;
    },
    RequestTestLlmSettings: (state) => {
      state.llmTestLoading = true;
      state.llmTestResult = null;
    },
    SuccessTestLlmSettings: (state, action) => {
      state.llmTestLoading = false;
      state.llmTestResult = action.payload;
    },
    FailureTestLlmSettings: (state, action) => {
      state.llmTestLoading = false;
      state.llmTestResult = action.payload;
    },
    ClearLlmTestResult: (state) => {
      state.llmTestResult = null;
    },
    RequestToggleLlmSettings: (state) => {
      state.toggleLlmLoading = true;
    },
    SuccessToggleLlmSettings: (state) => {
      state.toggleLlmLoading = false;
    },
    FailureToggleLlmSettings: (state) => {
      state.toggleLlmLoading = false;
    },
    RequestCoreServers: (state) => {
      state.coreServersLoading = true;
    },
    SuccessCoreServers: (state, action) => {
      const { core_servers, core_map } = action.payload;
      state.coreMap = core_map;
      state.coreServers = core_servers;
      state.coreServersLoading = false;
    },
    FailureCoreServers: (state) => {
      state.coreMap = {};
      state.coreServers = [];
      state.coreServersLoading = false;
    },
    RequestUpdateCoreServers: (state) => {
      state.coreServersLoading = true;
    },
    SuccessUpdateCoreServers: (state) => {
      state.coreServersLoading = false;
    },
    FailureUpdateCoreServers: (state) => {
      state.coreServersLoading = false;
    },
    requestGetAutoSubmissionSettings: (state) => {
      state.autoSubmissionLoading = true;
    },
    successGetAutoSubmissionSettings: (state, action) => {
      state.autoSubmissionLoading = false;
      const { submitType, settings } = action.payload;
      state.autoSubmission[submitType] = settings;
    },
    failureGetAutoSubmissionSettings: (state) => {
      state.autoSubmissionLoading = false;
    },
    requestSetAutoSubmissionSettings: (state) => {
      state.autoSubmissionLoading = true;
    },
    successSetAutoSubmissionSettings: (state, action) => {
      state.autoSubmissionLoading = false;
      const { submitType, settings } = action.payload;
      state.autoSubmission[submitType] = settings;
    },
    failureSetAutoSubmissionSettings: (state) => {
      state.autoSubmissionLoading = false;
    },
    requestResetAutoSubmissionSettings: (state) => {
      state.autoSubmissionLoading = true;
    },
  },
});

export default settingsSlice;
